import React, { useEffect, useState } from "react";
import {
  getGroups,
  getGroupMembers,
  getGroupRoles,
} from "../utilities/genesysCloudUtils";
import { permissionsToCheck } from "../utilities/helperUtils";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Groups({ setPageCount, pageNumber, setPageNumber, permissions, setTabName, opts,
  setOpts, setIsVisible, selectedExportRows = {}, exportStatus, onClearExportSelection, onExportCsv, onToggleExportRow, onToggleVisibleExportRows }) {
  const [groups, setGroups] = useState([]);
  // const [groupMembersPageNumber, setGroupMembersPageNumber] = useState(1);

  const groupRolesPermsActive = permissionsToCheck("authorization:grant:view", permissions)

  useEffect(() => {
    setPageNumber(1);
    setTabName("groups-tab");
    setOpts({})
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    generateGroups();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateGroups = () => {
    let opts = {
      pageSize: 100, // Number | Page size
      pageNumber: pageNumber,
      sortOrder: "ASC", // String | Ascending or descending sort order
    };
    getGroups(opts).then((data) => {
      setGroups(data.entities);
      setPageCount(data.pageCount);
    });
  };

  const generateGroupRoles = (groupId, index) => {
    getGroupRoles(groupId).then((data) => {
      const rolesMap = new Map();

      data.grants.forEach((grant) => {
        const roleName = grant.role.name;
        const divisionName =
          grant.division.id === "*" ? "All Divisions" : grant.division.name;

        if (rolesMap.has(roleName)) {
          rolesMap.get(roleName).push(divisionName);
        } else {
          rolesMap.set(roleName, [divisionName]);
        }
      });

      const roles = Array.from(rolesMap, ([role, divisions]) => ({
        role,
        divisions,
      }));

      setGroups((prevGroups) => {
        const updatedGroups = [...prevGroups];
        updatedGroups[index].grants = roles;
        return updatedGroups;
      });
    });
    console.log(groups[index]);
  };

  const generateGroupMembers = (groupId, index, pageNumber, pageCount) => {
    if (pageNumber && pageNumber < pageCount) {
      pageNumber++;
    } else {
      pageNumber = 1;
    }
    let opts = {
      pageSize: 100, // Number | Page size
      pageNumber: pageNumber, // Number | Page number
      sortOrder: "ASC", // String | Ascending or descending sort order
      // "expand": ["expand_example"] // [String] | Which fields, if any, to expand
    };
    getGroupMembers(groupId, opts).then((data) => {
      console.log("MEMBERS DATA", data);

      setGroups((prevGroups) => {
        const updatedGroups = [...prevGroups];
        if (!updatedGroups[index].members) {
          updatedGroups[index].members = data;
        } else {
          const existingMembers = new Set(updatedGroups[index].members.entities.map(member => member.id));
          const newMembers = data.entities.filter(member => !existingMembers.has(member.id));
          updatedGroups[index].members.entities.push(...newMembers);
          updatedGroups[index].members.pageNumber = data.pageNumber;
          updatedGroups[index].memberCountActive = data.total;
        }
        return updatedGroups;
      });
    });
    console.log(groups[index]);
  };

  const handleGroupRolesCheck = (event, groupId, index) => {
    console.log("checked", event.target.checked);
    if (event.target.checked && !groups[index].grants && groupRolesPermsActive) {
      generateGroupRoles(groupId, index);
    }
  };

  const handleGroupMembersCheck = (event, groupId, index) => {
    console.log("checked", event.target.checked);
    if (event.target.checked && !groups[index].members) {
      // setGroupMembersPageNumber(groupMembersPageNumber + 1)
      generateGroupMembers(groupId, index);
    }
  };

  const allVisibleSelected = groups.length > 0 && groups.every((group) => selectedExportRows[group.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: groups })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(groups, checked)}
      rowCount={groups.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Groups"
    >
      {groups ? (
        <>
          <table className="table groups-table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th>Count</th>
                <th>Group Name</th>
                <th>Description</th>
                <th></th>
                <th>Calls Enabled?</th>
                <th>UID</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group, index) => {
                return (
                  <tr key={group.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${group.name} for export`}
                        checked={Boolean(selectedExportRows[group.id])}
                        onChange={(event) => onToggleExportRow(group, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 100 + index + 1}
                    </th>
                    <td>{group.name}</td>
                    <td>{group.description}</td>
                    {/* <td>{group.rolesEnabled ? "Yes" : ""}</td> */}
                    <td>
                      {group.rolesEnabled && groupRolesPermsActive && (
                        <div className="collapse collapse-arrow">
                          <input
                            type="checkbox"
                            onChange={(event) =>
                              handleGroupRolesCheck(event, group.id, index)
                            }
                          />

                          <div className="collapse-title">
                            {group.rolesEnabled ? "Roles: ✔" : ""}
                          </div>
                          <div className="collapse-content">
                            <div className="overflow-x-auto">
                              <table className="table table-sm groups-role-table">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>Entity Name</th>
                                    <th>Division</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {group.grants &&
                                    group.grants.map((grant, index) => {
                                      return (
                                        <tr key={index + 1}>
                                          <td>{index + 1}</td>
                                          <td>{grant.role}</td>
                                          <td>
                                            {grant.divisions.map(
                                              (division, index) => {
                                                return (
                                                  <p key={index}>{division}</p>
                                                );
                                              }
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {group.memberCount !== 0 && (
                        <div className="collapse collapse-arrow">
                          <input
                            type="checkbox"
                            onChange={(event) =>
                              handleGroupMembersCheck(event, group.id, index)
                            }
                          />
                          <div className="collapse-title">
                            Members: {group.memberCount}
                          </div>
                          <div className="collapse-content">
                            <div className="overflow-x-auto">
                              <table className="table table-sm groups-member-table">
                                {group.members &&
                                  group.memberCountActive !== 0 && (
                                    <thead>
                                      <tr>
                                        <th></th>
                                        <th>Entity Name</th>
                                        <th>Owner</th>
                                      </tr>
                                    </thead>
                                  )}

                                <tbody>
                                  {group.members &&
                                    group.members.entities.map((member, index) => {
                                      return (
                                        <tr key={index + 1}>
                                          <td>{index + 1}</td>
                                          <td>{member.name}</td>
                                          <td>
                                            {group.owners.some((owner) => owner.id === member.id) ? "✔" : ""}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>

                                {group.members &&
                                  group.memberCount -
                                  group.members.total !==
                                  0 && (
                                    <tfoot>
                                      <tr>
                                        <td colSpan="2">
                                          {group.memberCount -
                                            group.members.total}{" "}
                                          inactive user
                                          {group.memberCount -
                                            group.members.total >
                                            1
                                            ? "s"
                                            : ""}
                                        </td>
                                      </tr>
                                    </tfoot>
                                  )}
                              </table>
                              {group.members &&
                                group.members.pageCount !==
                                group.members.pageNumber && (
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      // setGroupMembersPageNumber(groupMembersPageNumber + 1);
                                      generateGroupMembers(
                                        group.id,
                                        index,
                                        group.members.pageNumber,
                                        group.members.pageCount
                                      );
                                    }}
                                  >
                                    Load more
                                  </button>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                    </td>
                    <td>{group.callsEnabled ? "YES ✔" : ""}</td>
                    <td>
                      <kbd className="kbd">{group.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
